import { toast } from '@approvalmax/ui/src/components';
import { errorHelpers } from '@approvalmax/utils';
import { selectors } from 'modules/common';
import { domain } from 'modules/data';
import { useEffect } from 'react';
import {
    SetXeroBudgetCheckPeriod,
    SetXeroBudgetZeroAmountHandlingType,
    useSetXeroBudgetCheckPeriod,
    useSetXeroBudgetZeroAmountHandlingType,
} from 'shared/data/webApp/v1';

import { messages } from '../messages';

export const useSetBudgetOptionsMutation = (company: selectors.types.ExpandedCompany) => {
    const {
        mutate: setXeroBudgetZeroAmountHandlingType,
        isLoading: isLoadingSetXeroBudgetZeroAmountHandlingType,
        isSuccess: isSuccessSetXeroBudgetZeroAmountHandlingType,
    } = useSetXeroBudgetZeroAmountHandlingType();
    const {
        mutate: setXeroBudgetCheckPeriod,
        isLoading: isLoadingSetXeroBudgetCheckPeriod,
        isSuccess: isSuccessSetXeroBudgetCheckPeriod,
    } = useSetXeroBudgetCheckPeriod();

    const integrationType = company.integration?.integrationType;
    const isZeroAmountsAvailable =
        integrationType === domain.IntegrationType.Xero
            ? company.betaFeatures.includes(domain.CompanyBetaFeature.BudgetingZeroAmounts)
            : true;

    const isSuccess =
        isSuccessSetXeroBudgetCheckPeriod &&
        ((isZeroAmountsAvailable && isSuccessSetXeroBudgetZeroAmountHandlingType) || true);

    const setBudgetOptions = (data: SetXeroBudgetCheckPeriod['body'] & SetXeroBudgetZeroAmountHandlingType['body']) => {
        const { companyId, budgetId, zeroAmountHandlingType, ...otherData } = data;

        if (!integrationType) {
            throw errorHelpers.notImplementedError();
        }

        if (isZeroAmountsAvailable) {
            setXeroBudgetZeroAmountHandlingType({
                body: { companyId, budgetId, zeroAmountHandlingType },
            });
        }

        return setXeroBudgetCheckPeriod({
            body: { companyId, budgetId, ...otherData },
        });
    };

    useEffect(() => {
        if (isSuccess) {
            toast.success(messages.successUpdated);
        }
    }, [isSuccess]);

    return {
        setBudgetOptions,
        isLoading: isLoadingSetXeroBudgetZeroAmountHandlingType || isLoadingSetXeroBudgetCheckPeriod,
        isSuccess,
    };
};
